export default __webpack_public_path__ + "static/media/reloadFaq2.c73bb469.png";